export interface ValidationPatterns {
  email: RegExp;
  phoneGeneric: RegExp;
  onlyNumber: RegExp;
  vehicleId: RegExp;
  onlyLetters: RegExp;
  compartmentSsccId: RegExp;
  [key: string]: RegExp;
}

export interface FieldRule<TValue = unknown, TContext = unknown> {
  required?: boolean;
  hidden?: boolean;
  disabled?: boolean;
  patternKey?: keyof ValidationPatterns;
  customValidator?: (value: TValue, ctx: TContext) => boolean | string;
  isArray?: boolean;
  elementRules?: FormRuleSet;
  shouldBeUnique?: boolean;
}

export type FormRuleSet = Record<string, FieldRule>;

export type PageRuleSection = FormRuleSet;

export type PageRuleSet = Record<string, PageRuleSection>;

export interface LocationFeatureFlags {
  showInspectionRedirectLink?: boolean;
}

export interface LocationValidationRuleEntry {
  pages: {
    [pageName: string]: PageRuleSet | undefined;
  };
  featureFlags?: LocationFeatureFlags;
}

export interface LocationValidationRules {
  [locationCode: string]: LocationValidationRuleEntry;
}
